import React, { FC } from 'react';
import {
    SkeletonBlock,
    SkeletonPageHeader,
    SkeletonPageShell,
    SkeletonRow,
    SkeletonStack,
    SkeletonTable,
    SkeletonTableRow
} from 'src/components/widgets/skeleton';

export const TranslationTableSkeleton: FC = () => (
    <SkeletonStack aria-hidden='true' $gap='12px'>
        <SkeletonRow $justify='space-between'>
            <SkeletonBlock $width='240px' $height='36px' />
            <SkeletonBlock $width='220px' $height='32px' />
        </SkeletonRow>
        <SkeletonTable>
            {Array.from({ length: 3 }, (_, index) => (
                <SkeletonTableRow key={index} $columns='1fr 1fr'>
                    <SkeletonBlock $width='70%' $height='16px' />
                    <SkeletonStack $gap='8px'>
                        <SkeletonBlock $height='36px' />
                        <SkeletonBlock $width='90px' $height='12px' />
                        <SkeletonBlock $height='36px' />
                        <SkeletonBlock $width='90px' $height='12px' />
                    </SkeletonStack>
                </SkeletonTableRow>
            ))}
        </SkeletonTable>
    </SkeletonStack>
);

export const TranslationsPageSkeleton: FC = () => (
    <SkeletonPageShell aria-hidden='true'>
        <SkeletonPageHeader>
            <SkeletonBlock $width='220px' $height='26px' />
        </SkeletonPageHeader>
        <SkeletonStack $gap='20px'>
            <SkeletonBlock $height='72px' />
            <SkeletonStack $gap='12px'>
                <SkeletonBlock $width='100px' $height='16px' />
                <SkeletonBlock $height='40px' />
                <SkeletonBlock $width='70%' $height='12px' />
            </SkeletonStack>
            <SkeletonRow $gap='12px'>
                <SkeletonBlock $width='180px' $height='28px' />
                <SkeletonBlock $width='220px' $height='28px' />
            </SkeletonRow>
            <TranslationTableSkeleton />
        </SkeletonStack>
    </SkeletonPageShell>
);
